import Image from 'next/image';
import AsideNavLink from '../../components/aside-nav-link';
import AsideLayout from '../../components/layouts/aside-layout';
import MainLayout from '../../components/layouts/main-layout';
import HeroImage from '../../public/img/hero/disclaimer_1920_640.jpg';
import Head from 'next/head';

export default function Disclaimer() {
    return (
        <MainLayout>
            <Head>
                <title>Disclaimer | Solvar</title>
                <meta name="description" content="Solvar disclaimer."></meta>
            </Head>
            <AsideLayout
                heroImage={ HeroImage }
                location={
                    <p className="capitalize text-bb">
                        <span className="font-bold">Legal</span> › Disclaimer
                    </p>
                }
                aside={
                    <>
                        <h6 className="text-h3 text-bb pb-20">Legal</h6>
                        <AsideNavLink href="/legal/privacy-policy">Privacy Policy</AsideNavLink>
                        <AsideNavLink href="/docs/solvar-modern-slavery-statement-2025.pdf" target="_blank">Modern Slavery Statement 2025</AsideNavLink>
                        <AsideNavLink href="/legal/disclaimer" active={true}>Disclaimer</AsideNavLink>
                    </>
                }
            >
                <h1 className="text-bb pb-40">Disclaimer</h1>
                <div className="sol-markdown-content">
                    <p>The information contained in this website is for general information purposes only.</p>
                    <p>This information is provided by Solvar Limited and whilst we endeavour to keep the information up-to-date and correct, Solvar Limited gives no warranty and accepts no responsibility for the accuracy or the completeness of the material. Any reliance the user places on such information is therefore strictly at their own risk.</p>
                    <p>Solvar Limited reserves the right at any time to make changes, as it deems appropriate. Links to other websites are inserted for convenience and inclusion of any links does not necessarily imply a recommendation or endorse the views expressed within them.</p>
                    <p>&nbsp;</p>
                    <p className="text-right">Version 14/11/2022</p>
                </div>
            </AsideLayout>
        </MainLayout>
    );
}